import React from 'react';
import GlobalStyles from '../../GlobalStyles';
import Footer from '../Footer/Footer';

const Documentation = () => (
    <div>
        <GlobalStyles />
        <div className='wrapper'>
            <div>
                <h1> Documentation will be added Later. </h1>
            </div>
        </div>
        <Footer />
    </div>
);

export default Documentation;
